import React from 'react';

const CreditPolicyDetailContext = React.createContext({
  currentEndoso: null,
  setCurrentEndoso: () => {},
});

export default CreditPolicyDetailContext;
